export default "__VITE_PUBLIC_ASSET__49c68646__"